module.exports = __webpack_public_path__ + "img/fcu1.7939042f.jpg";